(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire21b6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire21b6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gC3Id", function(module, exports) {
//
// ScrollAnchors.js -- auto scroll-to on clickesons
//
// Auto-initialization from elements
// --------------------------------------
// HTML:  <a href="#somewhere" class="... js-scrollAnchors">
//
// JS:    require('./ScrollAnchors').auto_add();
//
// Options:
//    data-scrollanchors-speed="<number>" -- override the global default
//                                           for this element
//    data-scrollanchors-offset="<number>" -- offset the target position
//                                            by <number> pixels
//    data-scrollanchors-set-history="true|false"  -- override the setting for set_history.
//                                                    case sensitive.
//
// Options set as data attributes take precedence over those
// set programmatically.
//
// This then allows us to alter the options on an element after
// initializing, just by updating the data attributes.
//
//
// Programmatic initialization
// --------------------------------------
// HTML:  <a href="#somewhere">
//
// JS:    var a_element = ~;
//        var ScrollAnchors = require('./ScrollAnchors');
//        ScrollAnchors.add(a_element);
//
//
// Global defaults
// --------------------------------------
// - Default is a speed of 1 (equivalent to 1000px/s)
// - Change the default everywhere on the current page with:
//     ScrollAchors.set_defaults({ speed: 2 });
// - Set_history: whether or not to push_state the #fragment
//

var $k3WGC = parcelRequire("k3WGC");
const $c1831315fd529aff$var$defaults = {
    speed: 1,
    set_history: true,
    offset: 0
};
function $c1831315fd529aff$var$state() {
    if (!window.scroll_anchors_state) window.scroll_anchors_state = {
        defaults: $c1831315fd529aff$var$defaults
    };
    return window.scroll_anchors_state;
}
function $c1831315fd529aff$var$get_data_options(el_toggle) {
    const opts = {};
    set_opt_if_present("data-scrollanchors-speed", "speed");
    set_opt_if_present("data-scrollanchors-offset", "offset");
    set_opt_if_present("data-scrollanchors-set-history", "set_history");
    if (opts.hasOwnProperty("speed")) {
        if (opts.speed.match(/^[1-9][0-9\.]*$/)) opts.speed = parseFloat(opts.speed);
        else delete opts.speed;
    }
    if (opts.hasOwnProperty("offset")) {
        if (opts.offset.match(/-?\d+/)) opts.offset = parseFloat(opts.offset);
        else delete opts.offset;
    }
    return opts;
    function set_opt_if_present(attrib, internal_name) {
        if (el_toggle.hasAttribute(attrib)) {
            opts[internal_name] = el_toggle.getAttribute(attrib);
            if (internal_name === "set_history") opts[internal_name] = opts[internal_name] === "true";
        }
    }
}
function $c1831315fd529aff$var$cb_click(ev) {
    ev.preventDefault();
    const target_hash = this.getAttribute("href").substr(1);
    const target = document.getElementById(target_hash);
    const opts = {
        ...$c1831315fd529aff$var$state().defaults,
        ...$c1831315fd529aff$var$get_data_options(this)
    };
    console.log(opts);
    if (target) {
        if (opts.set_history) history.pushState(null, null, `${location.pathname}${location.search || ""}#${target_hash}`);
        // check if growl and sticky nav is present and add offset accordingly
        const growl = document.querySelector(".js-site-growl");
        const stickyNav = document.querySelector(".b-hero_topbar_pos");
        if (growl && growl.offsetHeight > 0 || stickyNav && stickyNav.offsetHeight > 0) {
            const growlHeight = growl?.offsetHeight ?? null;
            const stickyNavHeight = stickyNav?.offsetHeight ?? null;
            if (growlHeight) opts.offset = parseInt(opts.offset) - growlHeight;
            if (stickyNavHeight) opts.offset = parseInt(opts.offset) - stickyNavHeight;
            console.log(opts);
        }
        $k3WGC.scroll_to_element(target, opts);
    }
}
var $c1831315fd529aff$var$exp = {
    add (el_toggle) {
        el_toggle.addEventListener("click", $c1831315fd529aff$var$cb_click);
    },
    auto_add () {
        const items = Array.from(document.getElementsByClassName("js-scrollAnchors"));
        items.forEach((item)=>$c1831315fd529aff$var$exp.add(item));
    },
    remove (el_toggle) {
        el_toggle.removeEventListener("click", $c1831315fd529aff$var$cb_click);
    },
    auto_remove () {
        const items = Array.from(document.getElementsByClassName("js-scrollAnchors"));
        items.forEach($c1831315fd529aff$var$exp.remove);
    },
    set_defaults (def) {
        Object.assign($c1831315fd529aff$var$state().defaults, def);
    }
};
module.exports = $c1831315fd529aff$var$exp;

});
parcelRegister("k3WGC", function(module, exports) {

$parcel$export(module.exports, "scroll_to_element", () => $e9b19c58ddd77e8c$export$b936af74b22bb9ca);
//
// scroll-to -- a simple scroller
//    options:
//       easing      function, default is quint ease out
//
//       duration    duration of scroll (seconds)
//       OR:
//       speed       (a speed of 1 corresponds to 1000 pixels in 1 second)
//                   default: duration: 1 second
//
//       offset      number of pixels to 'miss' the target by, default 0
//

var $bMZtg = parcelRequire("bMZtg");
function $e9b19c58ddd77e8c$var$quint_ease_out(t) {
    return (t -= 1) * t * t * t * t + 1;
}
const $e9b19c58ddd77e8c$var$defaults = {
    duration: 1000,
    easing: $e9b19c58ddd77e8c$var$quint_ease_out
};
function $e9b19c58ddd77e8c$var$state() {
    if (!window._scrollToState) window._scrollToState = {
        raf_id: null,
        t_start: null,
        from: null,
        to: null,
        opts: {},
        offset_providers: []
    };
    return window._scrollToState;
}
function $e9b19c58ddd77e8c$export$8c21dfb8fd092094() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
}
// scroll_to_y
// --------------------------------
function $e9b19c58ddd77e8c$export$3f4fdea55e2bf14b(_to, _opts, disable_offset_providers) {
    $e9b19c58ddd77e8c$export$70b61ad426ddbe54();
    $e9b19c58ddd77e8c$var$bind_cancelers();
    const s = $e9b19c58ddd77e8c$var$state();
    s.opts = Object.assign({}, $e9b19c58ddd77e8c$var$defaults, _opts || {});
    s.from = $e9b19c58ddd77e8c$export$8c21dfb8fd092094();
    if (s.opts.hasOwnProperty("offset")) _to += _opts.offset;
    if (!disable_offset_providers) _to -= $e9b19c58ddd77e8c$var$state().offset_providers.reduce(function(accum, el) {
        return accum + el.offsetHeight;
    }, 0);
    s.to = (0, $bMZtg.default)(_to, [
        0,
        document.body.offsetHeight - window.innerHeight
    ]);
    if (s.opts.speed) s.opts.duration = $e9b19c58ddd77e8c$var$get_duration(s.opts.speed, Math.abs(s.to - s.from));
    $e9b19c58ddd77e8c$var$enqueue_frame();
}
// scroll_to_element
// --------------------------------
function $e9b19c58ddd77e8c$export$b936af74b22bb9ca(element, _opts) {
    const _to = element.getBoundingClientRect().top + $e9b19c58ddd77e8c$export$8c21dfb8fd092094() - parseInt(getComputedStyle(element, null).marginTop);
    $e9b19c58ddd77e8c$export$3f4fdea55e2bf14b(_to, _opts);
}
// scroll_to_top
// --------------------------------
function $e9b19c58ddd77e8c$export$9c319bff55199f49(_opts) {
    _opts = _opts || {};
    _opts.to = 0;
    _opts.offset = 0;
    $e9b19c58ddd77e8c$export$3f4fdea55e2bf14b(0, _opts, true);
}
// cancel
// --------------------------------
function $e9b19c58ddd77e8c$export$70b61ad426ddbe54() {
    const s = $e9b19c58ddd77e8c$var$state();
    cancelAnimationFrame(s.raf_id);
    s.raf_id = null;
    s.t_start = null;
    $e9b19c58ddd77e8c$var$unbind_cancelers();
}
// offset-providers
// --------------------------------
function $e9b19c58ddd77e8c$export$4bc7fef3cfe70dae(el) {
    $e9b19c58ddd77e8c$var$state().offset_providers.push(el);
}
function $e9b19c58ddd77e8c$export$c17b8e41d26a04c4(el) {
    $e9b19c58ddd77e8c$var$state().offset_providers = $e9b19c58ddd77e8c$var$state().offset_providers.filter((p)=>p !== el);
}
// event binding & unbinding
// --------------------------------
const $e9b19c58ddd77e8c$var$cancel_events = [
    "mousedown",
    "wheel",
    "DOMMouseScroll",
    "mousewheel",
    "keyup",
    "touchstart"
];
function $e9b19c58ddd77e8c$var$bind_cancelers() {
    $e9b19c58ddd77e8c$var$cancel_events.forEach((t)=>window.addEventListener(t, $e9b19c58ddd77e8c$export$70b61ad426ddbe54));
}
function $e9b19c58ddd77e8c$var$unbind_cancelers() {
    $e9b19c58ddd77e8c$var$cancel_events.forEach((t)=>window.removeEventListener(t, $e9b19c58ddd77e8c$export$70b61ad426ddbe54));
}
// cb - perform scroll in RAF loop
// --------------------------------
function $e9b19c58ddd77e8c$var$cb(t) {
    const s = $e9b19c58ddd77e8c$var$state();
    if (s.t_start === null) s.t_start = t;
    t = (t - s.t_start) / s.opts.duration;
    t = s.opts.easing(t);
    const cur = Math.round(s.from + (s.to - s.from) * t);
    if (s.to > s.from && s.to > cur || s.to < s.from && s.to < cur) {
        window.scrollTo(0, cur);
        $e9b19c58ddd77e8c$var$enqueue_frame();
    } else $e9b19c58ddd77e8c$export$70b61ad426ddbe54();
}
function $e9b19c58ddd77e8c$var$get_duration(speed, distance) {
    return distance / speed;
}
function $e9b19c58ddd77e8c$var$enqueue_frame() {
    $e9b19c58ddd77e8c$var$state().raf_id = requestAnimationFrame($e9b19c58ddd77e8c$var$cb);
}

});
parcelRegister("bMZtg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8953dc46f19789a0$export$2e2bcd8739ae039);
//
// math-clamp.js - clamp a number to a range
//
function $8953dc46f19789a0$export$2e2bcd8739ae039(n, range) {
    range = range.sort();
    return Math.min(Math.max(n, range[0]), range[1]);
}

});



//
// legal.js
//
//
// translation.js
//

var $gC3Id = parcelRequire("gC3Id");
const $df8b278a67450085$var$translationSelect = document.querySelector("[data-select-translation]");
const $df8b278a67450085$var$legalContent = document.querySelector("[data-legal-content]");
const $df8b278a67450085$var$legalSections = document.querySelector("[data-legal-sections]");
$df8b278a67450085$var$translationSelect.addEventListener("change", $df8b278a67450085$var$translateChange);
async function $df8b278a67450085$var$translateChange(e) {
    // Fade out section content
    for(let i = 0; i < $df8b278a67450085$var$legalContent.children.length; i++)setTimeout(()=>{
        $df8b278a67450085$var$legalContent.children[i].style.transition = "opacity .6s";
        $df8b278a67450085$var$legalContent.children[i].style.opacity = "0";
    }, i * 200 + 400);
    // Fade out sections
    for(let i = 0; i < $df8b278a67450085$var$legalSections.children.length; i++)setTimeout(()=>{
        $df8b278a67450085$var$legalSections.children[i].style.transition = "opacity .6s";
        $df8b278a67450085$var$legalSections.children[i].style.opacity = "0";
    }, i * 200);
    // Fetch page content
    const postId = e.target.options[e.target.selectedIndex].value;
    const response = await fetch(`${window.site_url}?page_id=${postId}`);
    const text = await response.text();
    const div = document.createElement("div");
    div.innerHTML = text;
    // Get new legal content
    const fetchedLegalContent = div.querySelector("[data-legal-content]");
    $df8b278a67450085$var$legalContent.innerHTML = "";
    for(let i = 0; i < fetchedLegalContent.children.length; i++){
        fetchedLegalContent.children[i].style.transition = "opacity .6s";
        fetchedLegalContent.children[i].style.opacity = "0";
        $df8b278a67450085$var$legalContent.appendChild(fetchedLegalContent.children[i].cloneNode(true));
    }
    // Fade in new legal content
    for(let i = 0; i < $df8b278a67450085$var$legalContent.children.length; i++)setTimeout(()=>{
        $df8b278a67450085$var$legalContent.children[i].style.transition = "opacity .6s";
        $df8b278a67450085$var$legalContent.children[i].style.opacity = "1";
    }, i * 200 + 400);
    // Get new legal sections
    const fetchedLegalSections = div.querySelector("[data-legal-sections]");
    $df8b278a67450085$var$legalSections.innerHTML = "";
    for(let i = 0; i < fetchedLegalSections.children.length; i++){
        fetchedLegalSections.children[i].style.transition = "opacity .6s";
        fetchedLegalSections.children[i].style.opacity = "0";
        $df8b278a67450085$var$legalSections.appendChild(fetchedLegalSections.children[i].cloneNode(true));
    }
    // Fade in new legal sections
    for(let i = 0; i < $df8b278a67450085$var$legalSections.children.length; i++)setTimeout(()=>{
        $df8b278a67450085$var$legalSections.children[i].style.transition = "opacity .6s";
        $df8b278a67450085$var$legalSections.children[i].style.opacity = "1";
    }, i * 200);
    // Reinitialise smooth scroll for sections
    $gC3Id.auto_add();
}





})();
//# sourceMappingURL=module-legal.js.map
